import React from 'react';
import { FaLinkedinIn, FaGithub } from 'react-icons/fa';

const About = () => {
  const lottieUrl =
    'https://lottie.host/5123c39d-87df-40f7-8fcf-292fa96bacf2/rYVJgEzmCN.json';
  const SocialShare = [
    { Social: 'github.com/omkrjha', link: 'https://github.com/omkrjha' },
    {
      Social: 'linkedin.com/in/omkrjha/',
      link: 'https://www.linkedin.com/in/omkrjha/',
    },
  ];
  return (
    <>
      <section id='about' className='section theme-light dark-bg'>
        <div className='container'>
          <div className='row align-items-center justify-content-center'>
            <div
              className='col-md-6 col-lg-4'
              data-aos='fade-up'
              data-aos-duration='1200'
            >
              <div className='about-me'>
                <div className='img'>
                  {/* <div className='img-in'>
                    <img src={hariom} alt='about' />
                    
                  </div> */}
                  <lottie-player
                    src={lottieUrl}
                    background='transparent'
                    speed='1'
                    loop
                    autoplay
                  />
                  {/* <div className='info'>
                  <p>Full Stack Developer</p>
                  <h3>Hari Om Kumar jha</h3>
                </div> */}

                  {/* <Social /> */}

                  {/* End social icon */}
                </div>
                {/* End img */}

                {/* End info */}
              </div>
              {/* End about-me */}
            </div>
            {/* End col */}

            <div
              className='col-lg-7 ml-auto'
              data-aos='fade-up'
              data-aos-duration='1200'
              data-aos-delay='200'
            >
              <div className='about-info'>
                <div className='title'>
                  <h3>About Me</h3>
                </div>

                <div className='about-text'>
                  <p>
                    Welcome to my portfolio website! I am a passionate and
                    dedicated web developer with expertise in the MERN stack
                    (MongoDB, Express.js, React.js, and Node.js). As a fresher
                    in the industry, I am enthusiastic about creating innovative
                    and user-friendly web applications.
                  </p>
                  <p>
                    Through this platform, I aim to showcase my skills, projects
                    and my capabilities in web development. I am actively
                    seeking new opportunities to collaborate and grow as a
                    developer, and I'm excited to connect with potential
                    employers and fellow enthusiasts in the tech community.
                    Let's explore my work together
                  </p>
                </div>
                <div className='info-list'>
                  <div className='row'>
                    <div className='col-sm-6'>
                      <ul>
                        <li>
                          <label>Name: </label>
                          <span>Hari Om Kumar Jha</span>
                        </li>
                        <li>
                          <label>Phone: </label>
                          <span>(+91) 8800237039</span>
                        </li>
                        <li>
                          <label>Email: </label>
                          <span>omkrjha@outlook.com</span>
                        </li>
                        {/* <li>
                          <div className='nav justify-content-center justify-content-md-start'>
                            {SocialShare.map((val, i) => (
                              <a
                                key={i}
                                href={`${val.link}`}
                                rel='noreferrer'
                                target='_blank'
                              >
                                {val.Social}
                              </a>
                            ))}
                          </div>
                        </li> */}
                        {/* <li>
                          <label>Age: </label>
                          <span>{new Date().getFullYear() - 2000} years</span>
                        </li> */}
                      </ul>
                    </div>
                    <div className='col-sm-6'>
                      <ul>
                        <li>
                          <label>Location: </label>
                          <span>New Delhi</span>
                        </li>

                        <li>
                          <label>Github: </label>
                          <span>
                            <a
                              rel='noreferrer'
                              target='_blank'
                              href={SocialShare[0].link}
                            >
                              {SocialShare[0].Social}
                            </a>
                          </span>
                        </li>
                        <li>
                          <label>Linkedin: </label>
                          <span>
                            <a
                              rel='noreferrer'
                              target='_blank'
                              href={SocialShare[1].link}
                            >
                              {SocialShare[1].Social}
                            </a>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className='separated'
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + 'img/border-dark.png'
              })`,
            }}
          ></div>
        </div>
      </section>
    </>
  );
};

export default About;
